import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

function YearSelector({ selectedYear, onChange }) {
  const currentYear = React.useMemo(() => new Date().getFullYear(), []);

  const handleSelectedYear = React.useCallback((e) => onChange(e.target.value), [onChange]);

  return (
    <FormControl>
      <InputLabel id="year-label-id">Year</InputLabel>
      <Select
        label="Year"
        labelId="year-label-id"
        value={selectedYear}
        onChange={handleSelectedYear}
        sx={{ height: '3.125rem', mx: 0, padding: '0.625rem', minWidth: '5.25rem' }}
        data-cy="year-select"
      >
        <MenuItem data-cy="current-year" value={currentYear}>
          {currentYear}
        </MenuItem>
        <MenuItem data-cy="previous-year" value={currentYear - 1}>
          {currentYear - 1}
        </MenuItem>
        <MenuItem data-cy="previous-year2" value={currentYear - 2}>
          {currentYear - 2}
        </MenuItem>
        <MenuItem data-cy="previous-year3" value={currentYear - 3}>
          {currentYear - 3}
        </MenuItem>
        <MenuItem data-cy="previous-year4" value={currentYear - 4}>
          {currentYear - 4}
        </MenuItem>
      </Select>
    </FormControl>
  );
}

YearSelector.propTypes = {
  selectedYear: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default React.memo(YearSelector);
